import { Stack, Typography } from '@mui/material';
import React from 'react';
import { ReactComponent as SMMHubLogoImg } from 'assets/images/hub-logo.svg';

export const SMMHubLogo = () => {
  return (
    <Stack
      direction="row"
      gap={1}
      alignItems={'center'}
      justifyContent={'center'}
      sx={{ p: '10px' }}
    >
      <SMMHubLogoImg />
      <Typography variant="gradient" fontSize={20}>
        SMMHUB
      </Typography>
    </Stack>
  );
};
